

























import Vue from 'vue';
import { mapState } from 'vuex';
import HeadingColumns from './dumb/HeadingColumns.vue';
import OfferGroup from './OfferGroup.vue';
import Helpers from '../mixins/helpers';
// import Analytics from '../mixins/analytics';
import { EOfferType } from '../enums';
import { IOffersItem } from '@/types';

export default Vue.extend({
	name: 'CarHeadings',
	props: {
		type: {
			type: String
		},
		size: {
			type: String
		},
		hideFinance: {
			type: Boolean
		},
		showFinance: {
			type: Boolean
		},
		hideCash: {
			type: Boolean
		},
		disableDisclaimer: {
			type: Boolean
		}
	},
	components: {
		HeadingColumns,
		OfferGroup
	},
	computed: {
		...mapState({
			app(): any { return this.$store.state.app },
			vehicle(): any { return this.$store.state.vehicle },
			finance(): any { return this.$store.state.finance },
			customer(): any { return this.$store.state.customer },
			dealer(): any { return this.$store.state.dealer },
			tpr(): any { return this.$store.state.tpr }
		}),
		hasDriveawayOffer(): boolean {
			const arr = this.vehicle.offers.filter((o: IOffersItem) => o.offerType == EOfferType.VehiclePrice);
			return !!arr.length;
		},
		showPriceDisclaimer(): boolean {
			return this.$store.getters.showPriceDisclaimer;
		},
		vehicleFinalPrice(): number {
            return this.$store.getters.vehicleFinalPrice;
		},
		flow(): string {
			return this.$store.getters.flow;
		},
		showCashHeadings(): boolean {
			return !this.hideCash;
		},
		showFinanceHeadings(): boolean {
			return !this.hideFinance && (
				this.flow == 'campaign' ||
				this.flow == 'business-campaign' ||
				(this.flow == 'get-tpr' && this.app.step != 0) ||
				this.flow == 'adjust-tpr' ||
				this.showFinance
			);
		},
		isCurrentOffer(): boolean {
			return this.vehicle.specialItem && this.vehicle.specialItem.SpecialType == 'Special Offer';
		},
		isGreatValue(): boolean {
			return this.vehicle.specialItem && this.vehicle.specialItem.SpecialType == 'Great Value';
		},
		cashSubHeading(): string {
			return this.isCurrentOffer ? '<span class="tb-pill">Current offer</span>' : '';
		},
		financeSubHeading(): string {
			if (this.flow == 'campaign'){
				return `<span class="tb-pill">Finance Offer</span>`;
			}
			if (this.flow == 'business-campaign'){
				return `<span class="tb-pill">Finance Offer</span>`;
			}
			else if (this.flow == 'adjust-tpr'){
				return `<span class="tb-pill tb-grey">Toyota Personalised Repayment Quote</span>`;
			}
			else {
				return '';
			}
		},
		financeItems(): Array<any> {
			const items = [];
			items.push({
				sup: this.finance.disclaimerKey,
				heading: Helpers.getFormattedPrice(this.finance.weeklyPayment) + '/wk',
				subtext: 'with Toyota Access' + (this.flow == 'business' || this.flow == 'business-campaign' ? ' for <br>business applicants' : '')
			});
			items.push({
				heading: this.finance.apr + '%',
				subtext: 'Interest rate'
			});
			if (this.flow != 'business' && this.flow != 'business-campaign'){
				items.push({
					heading: this.finance.comparisonRate + '%',
					subtext: 'Comparison rate'
				});
			}
			items.push({
				heading: Helpers.getFormattedPrice(Math.round(this.finance.gfv)),
				subtext: 'Guaranteed <br>Future Value',
				tooltip: {
					title: 'What is a Guaranteed Future Value?',
					value: 'Guaranteed Future Value (GFV) is the minimum value of your Toyota at the end of the loan term, as determined by Toyota Finance using the loan term and estimated kilometres per year. The GFV becomes the final payment of your loan if you choose to keep your&nbsp;vehicle.'
				}
			});
			return items;
		},
		cashItems(): Array<any> {
			const d = (this.isCurrentOffer ? 'Driveaway ': '') + this.vehicle.disclaimerKey;
			const subtext = this.vehicle.specialUniqueName ? this.vehicle.specialExtraInfo : '';
			let currentOfferSubtext = '';
			if (this.isCurrentOffer){
				currentOfferSubtext = '<span class="tb-offer-valid-to">Offer valid to ' + Helpers.shortFormattedDate(this.vehicle.specialItem.ValidTo) + '</span>';
			}
			return [{
				subHeading: !this.isCurrentOffer ? 'Total Driveaway' : (this.isGreatValue ? 'Toyota Value' : ''),
				heading: Helpers.getFormattedPrice(this.vehicleFinalPrice as number),
				sup: d,
				subtext: currentOfferSubtext + subtext,
				disclaimer: this.showPriceDisclaimer
			}];
		}
	}
});
